exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-icon.failed[data-v-6bfa8cf2] {\n  background-color: #b11623;\n  color: #FFF;\n}\ndiv.failed[data-v-6bfa8cf2] {\n  font-weight: 500;\n  color: #b11623;\n}\nspan.failed[data-v-6bfa8cf2] {\n  background-color: #b11623;\n  color: #FFF;\n  padding: 3px 10px;\n  margin-left: 10px;\n  vertical-align: text-top;\n}\n", ""]);

// exports
